import { TriogaLogo } from '../../../../packages/brand-assets/TriogaLogo.jsx';
import { Icon } from '../Icon.jsx';

export function Brand({ subtitle }) {
  return (
    <div className="brand">
      <span className="brand__lockup">
        <TriogaLogo className="brand__logo" />
        <span className="brand__product">MENU</span>
      </span>
      {subtitle && <span className="brand__subtitle">{subtitle}</span>}
    </div>
  );
}

export function AuthLayout({ title, description, role, children, footer }) {
  return (
    <div className="auth-page">
      <header className="auth-page__header"><Brand subtitle="Restaurant management" /></header>
      <main className="auth-page__main">
        <div className="auth-card">
          <span className="auth-card__role"><Icon name="shield" size={14} />{role}</span>
          <h1>{title}</h1>
          <p className="auth-card__description">{description}</p>
          {children}
          {footer && <div className="auth-card__footer">{footer}</div>}
        </div>
        <p className="auth-page__note">A little less admin. More time for great food.</p>
      </main>
      <footer className="auth-page__footer">Trioga Menu · Restaurant management, simplified.</footer>
    </div>
  );
}
